/*
 * Generated by graphql-codegen. Do not modify this file manually.
 */

// @ts-ignore Allow unused imports
import type * as Types from '../../graphql/schema';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type DisclosuresQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DisclosuresQuery = { __typename: 'Query', advisor?:
    | { __typename: 'InstitutionalAdvisor', id: string }
    | { __typename: 'PremiumAdvisor', id: string }
   | null, disclosures: { __typename: 'Disclosures', comprehensiveDisclosure: string } };


export const DisclosuresDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Disclosures"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"operationServiceConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"feature"},"value":{"kind":"StringValue","value":"content_disclosures","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advisor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disclosures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comprehensiveDisclosure"}}]}}]}}]} as unknown as DocumentNode<DisclosuresQuery, DisclosuresQueryVariables>;